export const SessionIdSize = 1000;

export const sessionId = (): string => {
  const SessionIdLength: number = Math.floor(Math.log10(SessionIdSize));
  return String(Math.floor(Math.random() * SessionIdSize)).padStart(SessionIdLength, "0");
};
